var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.3657,
    height: 18,
    transform: "translate(0.171387)",
    fill: "#D32F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71704 4.5H4.41418M4.41418 4.5H17.9913M4.41418 4.5V15C4.41418 15.3978 4.59299 15.7794 4.91127 16.0607C5.22954 16.342 5.66122 16.5 6.11133 16.5H14.597C15.0472 16.5 15.4788 16.342 15.7971 16.0607C16.1154 15.7794 16.2942 15.3978 16.2942 15V4.5H4.41418ZM6.9599 4.5V3C6.9599 2.60218 7.1387 2.22064 7.45698 1.93934C7.77526 1.65804 8.20693 1.5 8.65704 1.5H12.0513C12.5014 1.5 12.9331 1.65804 13.2514 1.93934C13.5697 2.22064 13.7485 2.60218 13.7485 3V4.5",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash-white.f7d3f0d0bbbd67ef2e678efdc93627ac.svg";
export { ForwardRef as ReactComponent };